module.exports = __webpack_public_path__ + "static/media/33_CORTINAO_BOJO_TRIANGULAR.afec2f9f.jpg";